// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__1SbG3","input":"Search_input__WAgg-","icon":"Search_icon__2VHD_","active":"Search_active__1g0E2"};